import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import FirstClubForm from "../../components/auth/FirstClubFrom";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const FirstClub = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="text-center mt-4 flex flex-col gap-8">
        <div className="flex flex-col gap-5">
          <PageTitle title={Auth?.first_club.first_club_title} />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.first_club.first_club_subtitle}
          </p>
        </div>

        <FirstClubForm />
      </div>
    </AuthLayout>
  );
};

export default FirstClub;
